import {CompanyProfile} from '../../features/company/profile/types';

export const handleCompanyLocationsOptions = (companyLocations: CompanyProfile['locations']) => {
  const remoteLocationOption = [
    {
      id: 'remote',
      label: 'Remote',
    },
  ];

  const locationsOptionsRestructured = companyLocations?.map((location) => {
    return {
      id: location.resourceId,
      label: location.city,
    };
  });

  return [...locationsOptionsRestructured, ...remoteLocationOption];
};
